import styled from 'styled-components'
import { components } from 'react-select'

import { InnerComponent } from 'components/utils/innerReactSelectComponents'

const StyledWrapper = styled(InnerComponent).attrs({ Component: components.ValueContainer })`
  &.react-select__value-container {
    padding: 0;
    line-height: 16px;
    cursor: pointer;
  }
`

const ValueContainer = (props) => {
  return (
    <StyledWrapper {...props} />
  )
}

export default ValueContainer
